import React from 'react';

const Logo = ({ imageSrc }) => {
  return <img src={imageSrc} className='App-logo' alt='logo' />;
};

export default Logo;
